'use client';

import { c as _c } from "react/compiler-runtime";
import { Avatar, Chip } from "@heroui/react";
import { cn } from "@/util/cn";
import { projTheme } from "@/constants/project-specific/theme";
interface FarmChipProps {
  name: string;
  className?: string;
  logo?: string;
  size?: "sm" | "md" | "lg" | undefined;
  color?: "primary" | "default" | "secondary" | "success" | "warning" | "danger" | undefined;
  variant?: "solid" | "bordered" | "light" | "flat" | "faded" | "shadow" | "dot" | undefined;
  onClick?: () => void;
}
export default function FarmChip(t0) {
  const $ = _c(33);
  let className;
  let color;
  let logo;
  let name;
  let onClick;
  let props;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      name,
      className,
      logo,
      size,
      color,
      variant,
      onClick,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = color;
    $[3] = logo;
    $[4] = name;
    $[5] = onClick;
    $[6] = props;
    $[7] = size;
    $[8] = variant;
  } else {
    className = $[1];
    color = $[2];
    logo = $[3];
    name = $[4];
    onClick = $[5];
    props = $[6];
    size = $[7];
    variant = $[8];
  }
  if (typeof logo === "undefined" || null) {
    const t1 = variant || projTheme.chip?.defaultVariant || "solid";
    const t2 = color || "default";
    const t3 = size || projTheme.chip?.defaultSize || "md";
    let t4;
    if ($[9] !== className) {
      t4 = cn("", className);
      $[9] = className;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== name || $[12] !== onClick || $[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
      t5 = <Chip variant={t1} color={t2} size={t3} className={t4} onClick={onClick} {...props}>{name}</Chip>;
      $[11] = name;
      $[12] = onClick;
      $[13] = props;
      $[14] = t1;
      $[15] = t2;
      $[16] = t3;
      $[17] = t4;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  const t1 = variant || projTheme.chip?.defaultVariant || "solid";
  const t2 = color || "default";
  const t3 = size || projTheme.chip?.defaultSize || "md";
  let t4;
  if ($[19] !== logo || $[20] !== name) {
    t4 = <Avatar name={name} src={logo} />;
    $[19] = logo;
    $[20] = name;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== className) {
    t5 = cn("", className);
    $[22] = className;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== name || $[25] !== onClick || $[26] !== props || $[27] !== t1 || $[28] !== t2 || $[29] !== t3 || $[30] !== t4 || $[31] !== t5) {
    t6 = <Chip variant={t1} color={t2} size={t3} avatar={t4} className={t5} onClick={onClick} {...props}>{name}</Chip>;
    $[24] = name;
    $[25] = onClick;
    $[26] = props;
    $[27] = t1;
    $[28] = t2;
    $[29] = t3;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  return t6;
}